<template>
    <footer class="bg-gray-50 text-gray-700 border-t shadow-inner py-12">
      <div class="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-5 gap-10">
        <!-- Branding & Description -->
        <div class="md:col-span-2 flex flex-col items-center text-center">
          <img src="@/assets/Logo_tagline.png" alt="Shvason Systems Logo" class="h-16 w-auto mb-2" />
          <p class="text-sm text-gray-900">
            Shvason Systems blends science and simplicity to purify the air around you — harnessing nanotechnology and AI to protect your health, one breath at a time.
          </p>
          <div class="flex gap-4 mt-6 text-2xl">
            <a href="https://x.com/yourhandle" target="_blank" aria-label="Twitter/X"><i class="fab fa-x-twitter"></i></a>
            <a href="mailto:contact@breatheasysolutions.com" aria-label="Email"><i class="fas fa-envelope"></i></a>
            <a href="https://instagram.com/yourhandle" target="_blank" aria-label="Instagram"><i class="fab fa-instagram"></i></a>
            <a href="https://facebook.com/yourhandle" target="_blank" aria-label="Facebook"><i class="fab fa-facebook"></i></a>
            <a href="https://wa.me/yourphonenumber" target="_blank" aria-label="WhatsApp"><i class="fab fa-whatsapp"></i></a>
            <a href="https://youtube.com/yourchannel" target="_blank" aria-label="YouTube"><i class="fab fa-youtube"></i></a>
          </div>
        </div>
  
        <!-- Quick Links -->
        <div>
          <h3 class="font-semibold text-gray-900 mb-4">Quick Links</h3>
          <ul class="space-y-2 text-sm text-gray-900">
            <li><router-link to="/" class="hover:underline">Home</router-link></li>
            <li><router-link to="/about-us" class="hover:underline">About Us</router-link></li>
            <li><router-link to="/products" class="hover:underline">Products</router-link></li>
            <li><a href="https://shvasonsystems.zohorecruit.in/jobs/Careers" target="_blank" rel="noopener">Careers</a></li>
            <li><router-link to="/contact-us" class="hover:underline">Contact</router-link></li>
          </ul>
        </div>
  
        <!-- Resources -->
        <div>
          <h3 class="font-semibold text-gray-900 mb-4">Resources</h3>
          <ul class="space-y-2 text-sm text-gray-900">
            <li><a href="/downloads/product-brochure.pdf" target="_blank" class="hover:underline">Product Brochure</a></li>
            <li><router-link to="/media" class="hover:underline">Media Coverage</router-link></li>
            <li><router-link to="/articles/aqi" class="hover:underline">Articles on AQI</router-link></li>
            <li><router-link to="/privacy-policy" class="hover:underline">Privacy Policy</router-link></li>
            <li><router-link to="/terms" class="hover:underline">Terms of Service</router-link></li>
          </ul>
        </div>
  
        <!-- Newsletter Signup -->
        <div>
          <h3 class="font-semibold text-gray-900 mb-4">Stay Updated</h3>
          <form @submit.prevent="subscribe">
            <input
              type="email"
              v-model="email"
              placeholder="Your email address"
              class="w-full px-4 py-2 mb-2 text-black rounded focus:outline-none"
              required
            />
            <button class="w-full bg-green-600 hover:bg-green-700 py-2 rounded text-white font-medium">
              Subscribe
            </button>
          </form>
          <p class="text-xs text-gray-400 mt-2">Receive updates, promotions, and clean air tips.</p>
        </div>
      </div>
  
      <!-- Copyright -->
      <div class="text-center text-sm text-gray-900 mt-10 border-t border-gray-800 pt-6">
        &copy; 2025 Shvason Systems Pvt Ltd. All rights reserved.
      </div>
    </footer>
  </template>
  
  <script>
  export default {
    name: 'HomePageFooter',
    data() {
      return {
        email: ''
      };
    },
    methods: {
      subscribe() {
        alert(`Subscribed with: ${this.email}`);
        this.email = '';
      }
    }
  };
  </script>
  